module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Devices/iMac-2d03ac7a157445c490ddacdf98cea542ffb781509442965e6e4b688e49003495.svg";